/* eslint-disable camelcase */
import axios from 'axios';
import { MENU_BANNER_RECOMMENDATION_ENDPOINT } from '@dynameat/constants';

export const bannerRecommendationListRequest = (menu__point_of_sale__guid) => axios.get(
  MENU_BANNER_RECOMMENDATION_ENDPOINT(), { params: { menu__point_of_sale__guid, page_size: 0 } }
);

export const createBannerRecommendationRequest = (recommendation) => axios.post(MENU_BANNER_RECOMMENDATION_ENDPOINT(), recommendation, { headers: { 'content-type': 'multipart/form-data' } });

export const editBannerRecommendationRequest = (recommendation__guid, recommendation) => axios.patch(MENU_BANNER_RECOMMENDATION_ENDPOINT(recommendation__guid), recommendation, { headers: { 'content-type': 'multipart/form-data' } });

export const deleteBannerRecommendationRequest = (recommendation__guid) => axios.delete(MENU_BANNER_RECOMMENDATION_ENDPOINT(recommendation__guid));
